// Libraries
import { IconProps } from '@chakra-ui/react';

/**
 * Enumeration representing EnvelopeIcon view boxes.
 */
export enum EnvelopeIconViewBox {
  /**
   * viewBox values for default.
   */
  DEFAULT = '0 0 51 39',
  /**
   * viewBox values for check.
   */
  CHECK = '0 0 62 51',
}

/**
 * Type of Envelope icon to display.
 */
export enum EnvelopeIconType {
  /**
   * Display the envelope icon.
   */
  DEFAULT = 'DEFAULT',
  /**
   * Display the envelope icon with check mark.
   */
  CHECK = 'CHECK',
}

/**
 * Props for the EnvelopeIcon component.
 */
export type EnvelopeIconProps = IconProps & {
  /**
   * The envelope icon status, which should be one of the keys defined in the EnvelopeIconType enum.
   */
  iconType?: keyof typeof EnvelopeIconType;
};

/**
 * Enumeration representing EnvelopeIcon paths.
 */
export enum EnvelopeIconPaths {
  /**
   * EyeIcon path to display an open eye.
   */
  DEFAULT = 'M50.0338 12.6305C50.4223 12.3217 51 12.6105 51 13.0986V33.4688C51 36.1084 48.8584 38.25 46.2188 38.25H4.78125C2.1416 38.25 0 36.1084 0 33.4688V13.1086C0 12.6105 0.567773 12.3316 0.966211 12.6404C3.19746 14.3736 6.15586 16.575 16.316 23.9561C18.4178 25.49 21.9639 28.7174 25.5 28.6975C29.0561 28.7273 32.6719 25.4303 34.6939 23.9561C44.8541 16.575 47.8025 14.3637 50.0338 12.6305ZM25.5 25.5C27.8109 25.5398 31.1379 22.5914 32.8113 21.3762C46.0295 11.7838 47.0355 10.9471 50.0836 8.55645C50.6613 8.1082 51 7.41094 51 6.67383V4.78125C51 2.1416 48.8584 0 46.2188 0H4.78125C2.1416 0 0 2.1416 0 4.78125V6.67383C0 7.41094 0.338672 8.09824 0.916406 8.55645C3.96445 10.9371 4.97051 11.7838 18.1887 21.3762C19.8621 22.5914 23.1891 25.5398 25.5 25.5Z',
  /**
   * EyeIcon path to display an closed eye.
   */
  CHECK = 'M0 11.4375C0 8.84863 2.08184 6.75 4.65 6.75H44.95C47.5172 6.75 49.6 8.84863 49.6 11.4375C49.6 12.9121 48.9122 14.2988 47.74 15.1875L46.3934 16.2031C39.9416 16.8281 34.5359 21.0859 32.2206 26.9258L26.66 31.125C25.5556 31.9551 24.0444 31.9551 22.94 31.125L1.86 15.1875C0.689072 14.2988 0 12.9121 0 11.4375ZM31 33.3125C31 37.4629 32.4628 41.2812 34.8944 44.25H6.2C2.77547 44.25 0 41.4473 0 38V17.6875L21.08 33.625C23.2887 35.2949 26.3112 35.2949 28.52 33.625L31.0775 31.6914C31.0291 32.2285 31 32.7656 31 33.3125Z',
}
